import { defineComponent, ref, inject, computed, onMounted, onBeforeUnmount, nextTick, resolveComponent, openBlock, createBlock, mergeProps, withModifiers, withCtx, createVNode, createTextVNode, toDisplayString, normalizeProps, guardReactiveProps, createElementVNode } from "vue";
import Joi from "joi";
import "../i18n-35335a5c.mjs";
import { i as isRecordObject } from "../helpers-674591c1.mjs";
import { u as useForm } from "../vee-validate.esm-8fad8707.mjs";
import { u as useDefaults, _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import { g as getFormFieldValidator, v as vuetifyConfig } from "../_validators-f968e1a2.mjs";
import "../index-64135f7d.mjs";
import { b as boundUseI18n } from "../_i18n-e414d464.mjs";
import { a as isValidConversationFeedback } from "../malarkeyTwilioAdapter-1c296255.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import "../_debug-8b5c3032.mjs";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import MalarkeyContactSearch from "./MalarkeyContactSearch.es.js";
import MalarkeyContactRoster from "./MalarkeyContactRoster.es.js";
import "../index-38c53cf2.mjs";
import "../index-fd2245c5.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../index-703c58ee.mjs";
import "../index-13be80af.mjs";
import "../_density-8094aebe.mjs";
import "../MalarkeyContactAvatar-1b079ba3.mjs";
import "../_VTextField-74fe2c1a.mjs";
import "../index-dbde2d54.mjs";
import "../_proxiedModel-031e293c.mjs";
import "../_VListItem-508e4b13.mjs";
import "../_VList-61c79735.mjs";
import "./constituants/MalarkeyContactSearchItem.es.js";
import "../MalarkeyContactSearchItem.vue_vue_type_script_lang-f1ada97c.mjs";
import "../_common-fcf3ef61.mjs";
import "../_internal-8e885689.mjs";
import "../_ui-71f9b37c.mjs";
import "../_patches-94e7586e.mjs";
const _sfc_main = defineComponent({
  name: "MalarkeyStartChat",
  components: {
    MalarkeyContactSearch,
    MalarkeyContactRoster
  },
  props: {
    /**
     * The title shown at the top of the widget
     */
    title: {
      type: String,
      default: void 0
    },
    /**
     * Designates the border-radius applied to the component. This can be xs, sm, md, lg, xl or a numeric value.
     */
    cardBorder: {
      type: [String, Number, Boolean],
      default: false
    },
    /**
     * The background color of the form. Can be the name of a theme color, a Vuetify Material Design color, or a CSS color value.
     */
    cardBgColor: {
      type: String,
      default: "transparent"
    },
    /**
     * Designates an elevation applied to the form between 0 and 24. You can find more information in the [Vuetify elevation documentation](https://vuetifyjs.com/en/styles/elevation/).
     */
    cardElevation: {
      type: [String, Number],
      default: void 0
    },
    /**
     * Removes the form's elevation.
     */
    cardFlat: {
      type: Boolean,
      default: false
    },
    /**
     * Apply a specific background image to the form.
     */
    cardBackgroundImage: {
      type: String,
      default: void 0
    },
    /**
     * Designates the border-radius applied to the form. This can be 0, xs, sm, true, lg, xl, pill, circle, and shaped. Find more information on available border radius classes in the [Vuetify Border Radius documentation](https://vuetifyjs.com/en/styles/border-radius/).
     */
    cardRounded: {
      type: [Boolean, Number, String],
      default: void 0
    },
    /**
     * Removes any applied border-radius from the form.
     */
    cardTile: {
      type: Boolean,
      default: false
    },
    /**
     * Applies a distinct style to the form.
     * Options are `text`, `flat`, `elevated`, `tonal`, `outlined`, and `plain`.
     */
    cardVariant: {
      type: String,
      default: "elevated"
    }
  },
  emits: [
    /**
     * Emitted when a conversation SID is retrieved from the server.
     */
    "sid",
    /**
     * Emitted when the form's "cancel" button is clicked
     */
    "cancel"
  ],
  setup(props, { emit }) {
    const participantsField = ref(null);
    const { t } = boundUseI18n();
    const http = inject("http");
    const identity = inject("identity");
    const alert = inject("alert");
    const alertFromApiResponse = inject(
      "alertFromApiResponse"
    );
    const mounted = ref(false);
    const authenticated = computed(() => {
      if (!mounted.value || !identity) {
        return null;
      }
      if (!identity.authenticated.value) {
        return false;
      }
      return identity.authenticated.value;
    });
    const propsWithDefaults = useDefaults(props, "MalarkeyStartChat");
    const cardDefaults = useDefaults({}, "VCard");
    const cardBindings = computed(() => ({
      border: propsWithDefaults.cardBorder || cardDefaults.border,
      bgColor: propsWithDefaults.cardBgColor || cardDefaults.bgColor,
      elevation: propsWithDefaults.cardElevation || cardDefaults.elevation,
      flat: propsWithDefaults.cardFlat || cardDefaults.flat,
      backgroundImage: propsWithDefaults.cardBackgroundImage || cardDefaults.backgroundImage,
      rounded: propsWithDefaults.cardRounded || cardDefaults.rounded,
      tile: propsWithDefaults.cardTile || cardDefaults.tile,
      variant: propsWithDefaults.cardVariant || cardDefaults.variant,
      style: {
        position: "relative"
      },
      class: ["m-start-chat"],
      tag: "form",
      action: "#",
      method: "post"
    }));
    const participantsFieldValidator = computed(
      () => getFormFieldValidator(
        t,
        Joi.array().items(Joi.string().required()).required(),
        t("malarkeyStartChat.fields.participants.label").toLowerCase()
      )
    );
    const {
      handleSubmit: handleFormSubmit,
      isSubmitting: formIsSubmitting,
      defineField
    } = useForm({
      initialValues: {
        participants: []
      },
      validationSchema: {
        participants: (val, ctx) => participantsFieldValidator.value(val, ctx)
      }
    });
    const participantsInFocus = ref(false);
    const [participantsFieldModel, participantsFieldBinds] = defineField(
      "participants",
      {
        label: t(`malarkeyStartChat.fields.participants.label`),
        validateOnBlur: true,
        validateOnChange: true,
        validateOnInput: false,
        validateOnModelUpdate: true,
        props: (state) => {
          const ret = {
            placeholder: t(`malarkeyStartChat.fields.participants.placeholder`),
            multiple: true,
            ...vuetifyConfig(state, participantsInFocus.value, "auto").props,
            onUpdatedFocus: (focused) => {
              participantsInFocus.value = focused;
            },
            onFocus: () => {
              participantsInFocus.value = true;
            },
            onBlur: () => {
              participantsInFocus.value = false;
            },
            chips: true,
            closableChips: true
          };
          return ret;
        }
      }
    );
    const isSubmitting = ref(false);
    let submissionAbortController = new AbortController();
    const submitForm = handleFormSubmit(
      async (values) => {
        if (isSubmitting.value || !values)
          return;
        if (submissionAbortController) {
          submissionAbortController.abort();
        }
        submissionAbortController = new AbortController();
        submissionAbortController.signal.addEventListener("abort", () => {
          isSubmitting.value = false;
        });
        isSubmitting.value = true;
        if (!http) {
          await alert(
            "errors.vueInjectionMissing.title",
            "errors.vueInjectionMissing.text"
          );
        } else {
          try {
            const { status, data } = await http.post(
              "/conversation",
              { ...values },
              {
                signal: submissionAbortController.signal,
                validateStatus: () => true
              }
            );
            if ([200, 201].includes(status) && isRecordObject(data) && "data" in data && isValidConversationFeedback(data.data)) {
              const { sid } = data.data;
              emit("sid", sid);
            } else {
              switch (status) {
                case 200:
                case 201:
                  await alert(
                    "errors.invalidIdentityFeedback.title",
                    "errors.invalidIdentityFeedback.text"
                  );
                  break;
                default:
                  await alertFromApiResponse(
                    data,
                    "malarkeyStartChat.errors.conversationSubmit",
                    {},
                    {
                      participants: t(
                        "malarkeyStartChat.fields.participants.label"
                      ).toLowerCase()
                    }
                  );
                  break;
              }
            }
          } catch {
            await alert("errors.httpCaught.title", "errors.httpCaught.text");
          }
        }
        isSubmitting.value = false;
      }
    );
    const submit = (event) => {
      event.preventDefault();
      submitForm();
    };
    const formIsProcessing = computed(
      () => formIsSubmitting.value || isSubmitting.value
    );
    const btnDefaults = useDefaults({}, "VBtn");
    const submitBtnDefaults = useDefaults(
      btnDefaults,
      "MalarkeyStartChatSubmitBtn"
    );
    const submitBtnBindings = computed(() => ({
      ...submitBtnDefaults,
      type: "submit",
      loading: formIsProcessing.value,
      disabled: !authenticated.value
    }));
    const cancelBtnDefaults = useDefaults(
      btnDefaults,
      "MalarkeyStartCancelBtn"
    );
    const cancelBtnBindings = computed(() => ({
      ...cancelBtnDefaults,
      type: "button",
      disabled: formIsProcessing.value || !authenticated.value
    }));
    const onCancelBtnClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      emit("cancel");
    };
    const formHeader = computed(
      () => propsWithDefaults.title || t(t(`malarkeyStartChat.title`))
    );
    const rosterSortFn = (a, b) => {
      if (a.isOnline !== b.isOnline) {
        return a.isOnline ? -1 : 1;
      }
      return 0;
    };
    const rosterClickOnFn = (event, item) => {
      if (!item) {
        return;
      }
      event.preventDefault();
      const val = item.identifier;
      if (val && participantsField.value) {
        participantsField.value.onUpdateModelValue([val]);
        nextTick(() => {
          submitForm();
        });
      }
    };
    const dbg = computed(() => ({
      mounted: mounted.value,
      identity: "undefined" !== typeof identity,
      identityAuthenticated: "undefined" === typeof identity ? false : identity.authenticated.value,
      authenticated: authenticated.value
    }));
    onMounted(() => {
      mounted.value = true;
      console.log({
        mounted: mounted.value,
        identity: "undefined" !== typeof identity,
        identityAuthenticated: "undefined" === typeof identity ? false : identity.authenticated.value,
        authenticated: authenticated.value
      });
    });
    onBeforeUnmount(() => {
      mounted.value = false;
    });
    return {
      cardBindings,
      submit,
      formHeader,
      submitBtnBindings,
      participantsFieldBinds,
      participantsFieldModel,
      rosterSortFn,
      rosterClickOnFn,
      participantsField,
      participantsInFocus,
      cancelBtnBindings,
      onCancelBtnClick,
      dbg
    };
  }
});
const _hoisted_1 = /* @__PURE__ */ createElementVNode("input", {
  type: "submit",
  name: "_submit",
  style: { "display": "none" }
}, null, -1);
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_toolbar_title = resolveComponent("v-toolbar-title");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_toolbar_items = resolveComponent("v-toolbar-items");
  const _component_v_toolbar = resolveComponent("v-toolbar");
  const _component_v_divider = resolveComponent("v-divider");
  const _component_MalarkeyContactSearch = resolveComponent("MalarkeyContactSearch");
  const _component_v_card_actions = resolveComponent("v-card-actions");
  const _component_v_list_subheader = resolveComponent("v-list-subheader");
  const _component_v_list = resolveComponent("v-list");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_MalarkeyContactRoster = resolveComponent("MalarkeyContactRoster");
  const _component_v_card = resolveComponent("v-card");
  return openBlock(), createBlock(_component_v_card, mergeProps(_ctx.cardBindings, {
    onSubmit: withModifiers(_ctx.submit, ["stop"])
  }), {
    default: withCtx(() => [
      _hoisted_1,
      createVNode(_component_v_toolbar, {
        flat: "",
        color: "transparent",
        density: "compact"
      }, {
        default: withCtx(() => [
          createVNode(_component_v_toolbar_title, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.formHeader), 1)
            ]),
            _: 1
          }),
          createVNode(_component_v_toolbar_items, null, {
            default: withCtx(() => [
              createVNode(_component_v_btn, normalizeProps(guardReactiveProps(_ctx.submitBtnBindings)), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$t("malarkeyStartChat.general.start")), 1)
                ]),
                _: 1
              }, 16),
              createVNode(_component_v_btn, mergeProps(_ctx.cancelBtnBindings, { onClick: _ctx.onCancelBtnClick }), {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.$t("malarkeyStartChat.general.cancel")), 1)
                ]),
                _: 1
              }, 16, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createVNode(_component_v_divider),
      createVNode(_component_v_card_actions, null, {
        default: withCtx(() => [
          createVNode(_component_MalarkeyContactSearch, mergeProps({
            ref: "participantsField",
            modelValue: _ctx.participantsFieldModel,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => _ctx.participantsFieldModel = $event)
          }, _ctx.participantsFieldBinds), null, 16, ["modelValue"])
        ]),
        _: 1
      }),
      createVNode(_component_v_divider),
      createVNode(_component_v_list, { class: "py-0" }, {
        default: withCtx(() => [
          createVNode(_component_v_list_subheader, null, {
            default: withCtx(() => [
              createTextVNode(toDisplayString(_ctx.$t("malarkeyStartChat.general.latestContacts")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      createVNode(_component_MalarkeyContactRoster, {
        class: "py-0",
        sortFn: _ctx.rosterSortFn,
        onClick: _ctx.rosterClickOnFn,
        limit: 5
      }, {
        empty: withCtx(() => [
          createVNode(_component_v_list_item, {
            title: _ctx.$t("malarkeyStartChat.general.noContacts")
          }, null, 8, ["title"])
        ]),
        _: 1
      }, 8, ["sortFn", "onClick"])
    ]),
    _: 1
  }, 16, ["onSubmit"]);
}
const MalarkeyStartChat = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyStartChat.vue"]]);
export {
  MalarkeyStartChat as default
};
//# sourceMappingURL=MalarkeyStartChat.es.js.map
